import {
  ActionIcon,
  Flex,
  Group,
  Popover,
  Text,
  Title,
  type TitleOrder,
} from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import type { ReactNode } from "react";

const SettingsHeader = ({
  title,
  description,
  infoContent,
  order = 2,
}: {
  title: string;
  description?: string | ReactNode;
  infoContent?: ReactNode;
  order?: TitleOrder;
}) => (
  <Flex direction="column" gap={8} align="flex-start" mb={8}>
    <Group gap="xs" align="center">
      <Title order={order}>{title}</Title>
      {infoContent && (
        <Popover width={400} position="bottom-start" withArrow shadow="md">
          <Popover.Target>
            <ActionIcon variant="subtle" color="gray" size="sm">
              <IconInfoCircle size={18} />
            </ActionIcon>
          </Popover.Target>
          <Popover.Dropdown>{infoContent}</Popover.Dropdown>
        </Popover>
      )}
    </Group>
    {description &&
      (typeof description === "string" ? (
        <Text c="dimmed" size="sm">
          {description}
        </Text>
      ) : (
        description
      ))}
  </Flex>
);

export default SettingsHeader;
